export default __webpack_public_path__ + "static/media/Civitas.cd4ce098.jpg";